<template>
  <v-alert v-if="task != null" type="info" variant="tonal" density="compact">
    El tipo de tarea "{{ task.task_type ? task.task_type.name : "-" }}" no tiene detalle planificado adicional.
  </v-alert>
</template>

<script>
export default {
  name: "TaskViewDetalleGenerico",
  props: {
    task: Object,
    descriptivos: { type: Array, default: () => [] },
  },
};
</script>
